import { PMCountCategoriesCard } from "@pimo/pimo-components/src/lib/pm-components";

import { getDropdownCount } from "../../../utils/dropdown-options";
import { getLocalizedCardCopy } from "../../../utils/get-localized-card-copy";
import {
  getItemName,
  getPluralOfItemName,
} from "../../../utils/get-plural-of-item-name";
import { isFieldEnabled } from "../../field-enabled";
import { DashboardCardContext } from "../context";

export function addCountofItemsStatusCard(ctx: DashboardCardContext) {
  const { view, language, projectName, projectNamePlural, getCardCopy } = ctx;

  const countofItemsStatusComponent = view.addComponent({
    component: PMCountCategoriesCard,
    layoutProps: {
      componentId: "countofItemsStatusComponent",
      labels: ["status", "count"],
      description: getCardCopy(language, "itemStatusCounts").description,
      title: getCardCopy(language, "itemStatusCounts").title,
    },
  });

  countofItemsStatusComponent.mapLayoutProps(({ language }) => {
    return {
      componentId: "countofItemsStatusComponent",
      labels: ["status", "count"],
      title: getCardCopy(language, "itemStatusCounts").title,
      description: getCardCopy(language, "itemStatusCounts").description,
    };
  });

  countofItemsStatusComponent.mapState(({ dashboard, settings, language }) => {
    const statusCounts = dashboard?._calculated?.statusCounts ?? {};
    const data = (settings?.configuration?.statusDefinition ?? []).map(
      (entry) => {
        return {
          label: entry.name ?? "",
          count: getDropdownCount(statusCounts, entry),
          color: entry.color ?? "",
        };
      }
    );

    return {
      title: getLocalizedCardCopy(language, "itemStatusCounts", {
        itemName: getItemName(settings?.configuration?.itemName, language),
        itemNamePlural: getPluralOfItemName(
          settings?.configuration?.itemName,
          language
        ),
        projectName,
        projectNamePlural,
      }).title,
      icon: "DonutLarge",
      data,
    };
  });

  countofItemsStatusComponent.mapVisibility(({ settings }) =>
    isFieldEnabled(settings, "status", "itemReporting")
  );
}
